import { Box, Button, Grid, Heading, HStack, Table, TableCaption, TableContainer, Tbody, Th, Td,Thead, Tr, Image, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import { RiDeleteBin6Line, RiDeleteBin7Fill } from 'react-icons/ri'
import Sidebar from '../Sidebar'
import CourseModal from './CourseModal'

const AdminCourses = () => {
  const courses=[{
      _id:'123abc',
      title:'nodeJs',
      category:'webdev',
      createdBy:'random',
      poster:{
        url:'https://zoro.to/images/zoro-min.png'
      },
      views:123,
      numOfVideos:12,
  }]
  const {isOpen,onClose,onOpen} = useDisclosure()
  const courseDetailsHandler=(userId)=>{
    onOpen();
  }
  const deleteBtnHandler=(userId)=>{
    console.log(userId);
  }
  const deleteLecBtnHandler=(courseId,lectureId)=>{
    console.log(courseId)
    console.log(lectureId)
  }
  const addLecHandler=(e,courseId,description,video,title)=>{
    e.preventDefault()
  }
  return (    
    <Grid minH={'100vh'} templateColumns={['1fr','5fr 1fr']} >
        <Box p={['0','8']} overflowX='auto'>
            <Heading my='16' children='All Users' textAlign={['center','left']} />
            <TableContainer w={['100vw','full']}>
              <Table variant={'simple'} size='lg'>
                <TableCaption>
                  All available courses in the database
                </TableCaption>
                <Thead>
                  <Tr>
                    <Th>Id</Th>
                    <Th>Posters</Th>
                    <Th>Title</Th>
                    <Th>Category</Th>
                    <Th>Creator</Th>
                    <Th isNumeric>Views</Th>
                    <Th isNumeric>Lectures</Th>
                    <Th isNumeric>Action</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {
                    courses.map(item=>(
                      <Row key={item._id} courseDetailsHandler={courseDetailsHandler} deleteBtnHandler={deleteBtnHandler} item={item}/>
                    ))
                  }
                </Tbody>
              </Table>
            </TableContainer>
            <CourseModal id='123' courseTitle='nodeJs' isOpen={isOpen} onClose={onClose} deleteButtonHandler={deleteLecBtnHandler} addLecHandler={addLecHandler} />
        </Box>
        <Sidebar/>
    </Grid>   
  )
}



function Row({item,courseDetailsHandler,deleteBtnHandler}){
  return(
    <Tr>
      <Td>#{item._id}</Td>
      <Td>
        <Image src={item.poster.url}/>
      </Td>
      <Td>{item.title}</Td>
      <Td>{item.category}</Td>
      <Td>{item.createdBy}</Td>
      <Td isNumeric>{item.views}</Td>
      <Td isNumeric>{item.numOfVideos}</Td>
      <Td isNumeric>
        <HStack justifyContent={'flex-end'}>
          <Button onClick={()=>{courseDetailsHandler(item._id)}} variant={'outline'} color='purple.500'>
            View Lectures
          </Button>
          <Button onClick={()=>{deleteBtnHandler(item._id)}} color={'purple.600'} >
            <RiDeleteBin7Fill />
          </Button>
        </HStack>
      </Td>
    </Tr>
  )
}

export default AdminCourses